import { useCallback, useMemo } from 'react';

import { CareServiceOrgansKey, TextToStructuredObservation } from '@/api';
import { useActiveKeyImages, useDefaultAndCommonFindings } from '@/shared/hook';
import { REPORT_LINK_KEY, ReportLinkKey } from '@/shared/model';

import { NECK_SUB_ORGAN } from './nav-menu.constant';

function getKeyImageCount(findings: TextToStructuredObservation[]): number {
  return findings.reduce((count, findingData) => {
    const keyImages = (findingData.renderedSummary.keyImages ?? []).filter(
      (ki) => ki.status !== 'deprecated',
    );

    return count + keyImages.length;
  }, 0);
}

export function useKiLabelCount(): (link: ReportLinkKey) => number {
  const activeKeyImageLabels = useActiveKeyImages();
  const mergedFindings = useDefaultAndCommonFindings();

  const neckFindings = useMemo(
    () => NECK_SUB_ORGAN.flatMap((organ) => mergedFindings[organ as CareServiceOrgansKey] || []),
    [mergedFindings],
  );

  return useCallback(
    (link: ReportLinkKey) => {
      if (link === REPORT_LINK_KEY.NECK) {
        return getKeyImageCount(neckFindings);
      }

      if (link === REPORT_LINK_KEY.KEY_IMAGES) {
        return activeKeyImageLabels.length;
      }

      return getKeyImageCount(mergedFindings[link as CareServiceOrgansKey] || []);
    },
    [neckFindings, mergedFindings, activeKeyImageLabels],
  );
}
